import { Address, Contact } from "@happy-legal/graphql-types";
import { Link } from "@mui/material";
import { formatStreetLine } from "../../utils";
import { BerlinDistrictsEnum } from "../../enums";

/**
 * Component to display addresses passed to it
 * @param address object containing Contact type data
 */
const AddressCard = ({ address }: { address: Address | Contact }) => {
  const phoneNumber = (address as Contact)?.phoneNumber;
  const emailAddress = (address as Contact)?.emailAddress;
  const hasName = !!(address?.firstName || address?.lastName);

  return (
    <>
      {/* Guarded: rendering the name unconditionally left a blank first
          line on every address that only has a street. */}
      {hasName && (
        <>
          {address?.firstName} {address?.lastName}
        </>
      )}
      {(address?.streetName ||
        address?.houseNumber ||
        address?.apartmentNumber) && (
        <>
          {hasName && <br />}
          {formatStreetLine(address?.streetName, address?.houseNumber)}{" "}
          {address?.apartmentNumber}
        </>
      )}
      {(address?.postalCode || address?.city) && (
        <>
          <br />
          {address?.postalCode} {address?.city}
        </>
      )}
      {(address?.district || address?.country) && (
        <>
          <br />
          {address?.district &&
            //@ts-ignore - string indexing without interface
            BerlinDistrictsEnum[address?.district]}{" "}
          {address?.country}
        </>
      )}
      {(phoneNumber || emailAddress) && <br />}
      {phoneNumber && (
        <>
          <br />
          <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>
        </>
      )}
      {emailAddress && (
        <>
          <br />
          <Link href={`mailto:${emailAddress}`}>{emailAddress}</Link>
        </>
      )}
    </>
  );
};

export default AddressCard;
